// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"40ec8640","626":"7941d58b"}[chunkId] + ".chunk.css";
};